import { cn } from "../lib/utils";

export interface LoadingProps {
  className?: string;
}

export function Loading({ className }: LoadingProps) {
  return (
    <div className={cn("flex items-center justify-center w-full", className)}>
      <i className="i-bp-spinner animate-spin w-8 h-8" />
    </div>
  );
}

Loading.FullHeight = function LoadingFullHeight({ className }: LoadingProps) {
  return (
    <div className={cn("min-h-[calc(100vh-128px)] flex items-center justify-center", className)}>
      <Loading />
    </div>
  );
};
